import OdinIcon from '../odin-icon/odin-icon.component';

const ContinuousScrollerDataLoadingIndicator = () => {
  return (
    <div className="odin-flex odin-w-full odin-flex-col odin-items-center odin-justify-center odin-overflow-hidden odin-pt-1">
      <OdinIcon icon="Loader" spin={true} />
    </div>
  );
};

export default ContinuousScrollerDataLoadingIndicator;
